module.exports = __webpack_public_path__ + "img/index_pic12.2be0cfa5.png";